/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useMemo } from 'react';
import {
	TableCell,
	TableRow,
	Typography,
	Button,
	Stack,
	Checkbox,
	Avatar,
	Chip,
	Tooltip,
	useTheme,
} from '@mui/material';
import {
	formatDate,
	formatDateString,
	getPipelineIcon,
	getUrlFromPipeline,
} from '@/utils/constants';
import { BlinkingCircle } from '../icons/BlinkingCircle';
import { useObjectContext } from '@/hooks/useObjectContext';
import { Link as RouterLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { closeDialog } from '@/features/dialog/dialogSlice';

export const PolicyDataRow = ({
	policy,
	handleCheckboxChange,
	hideCheckbox,
	selected = false,
	showDisabledRow = false,
	showRenewal = false,
}) => {
	const theme = useTheme();
	const dispatch = useDispatch();

	const showDisabled = showDisabledRow
		? policy?.associated ||
			policy?.linkedToCurrentDeal ||
			(policy?.policyTransactions === null && (policy?.policyTransactions ?? []).length > 0)
		: false;

	const handleLinkClick = (e) => {
		e.preventDefault();
		dispatch(closeDialog('editPolicyTransaction'));
		setTimeout(() => {
			window.location.href = `${getUrlFromPipeline(policy?.associatedDeal?.pipeline)}/${
				policy?.associatedDeal?.dealId
			}`;
		}, 100);
	};

	const url = useMemo(
		() =>
			`${getUrlFromPipeline(policy?.associatedDeal?.pipeline)}/${
				policy?.associatedDeal?.dealId
			}`,
		[policy?.associatedDeal?.pipeline, policy?.associatedDeal?.dealId],
	);

	const associatedDeal = policy?.associatedDeal?.dealName ?? null;

	return (
		<Tooltip
			title={
				showDisabled ? (
					<span>
						{policy?.linkedToCurrentDeal ? (
							'This policy has already been associated with this deal.'
						) : (
							<>
								This policy has already been associated with an existing deal{' '}
								{associatedDeal && (
									<a
										href={url}
										onClick={handleLinkClick}
										style={{ color: '#50A9FC', textDecoration: 'none' }}
									>
										{associatedDeal}
									</a>
								)}
							</>
						)}
					</span>
				) : (
					''
				)
			}
			placement='top'
		>
			<TableRow
				key={`table-row-${policy.Id}`}
				sx={{
					...(showDisabled && {
						backgroundColor: theme.palette.action.disabledBackground,
					}),
				}}
			>
				{!hideCheckbox && (
					<TableCell size='small' padding='checkbox' sx={{ alignItems: 'center' }}>
						<Checkbox
							checked={policy?.selected || showDisabled || selected}
							onChange={(event) => handleCheckboxChange(event, policy.Id)}
							color='primary'
							{...(showDisabled && { disabled: true })}
						/>
					</TableCell>
				)}
				<TableCell sx={{ whiteSpace: 'wrap' }}>
					{policy?.Description ?? policy?.BriefDescription ?? '-'}
				</TableCell>
				<TableCell width={'10%'}>{policy?.PolicyNumber}</TableCell>
				<TableCell>{policy?.ClassOfRiskName ?? policy?.ClassOfRisk}</TableCell>
				<TableCell>{policy.InsurerName}</TableCell>
				{showRenewal && <TableCell>{formatDateString(policy?.ToDate)}</TableCell>}
			</TableRow>
		</Tooltip>
	);
};
